import {Component, ViewChild}          from '@angular/core';
import {ApLoggerEditComponent}         from '../../entry-components/ap-settings-entry-components/ap-logger-edit.component';
import {ApMachinesLoggerEditComponent} from '../../entry-components/ap-settings-entry-components/ap-machines-logger-edit.component';
import {ApLoggerComponent}             from './logger/ap-logger.component';
import {ApMachinesLoggerComponent}     from './machineslogger/ap-machines-logger.component';
import {IApPermissionData}             from '../../ap-interface/interfaces';
import {ApPermissions}                 from 'invoker-transport';
import {AccessPermissionsStore}        from '../../stores/settings/access.permission.store';
import {FarmUsersStore}                from '../../stores/farm/farm.users.store';
import {FormStore}                     from '../../stores/layout/form.store';
import {MapViewStore}                  from '../../stores/layout/mapview.store';


/**
 * Enumeration of all ressource tabs
 */
export enum RessourceTabs {
  Logger = 0,
  MachinesLogger = 1,
}

@Component({
  selector: 'ap-logger-settings',
  templateUrl: './ap-logger-settings.component.html'
})
export class ApLoggerSettingsComponent {
  public apPermissionData: IApPermissionData;
  public ApPermissions = ApPermissions;

  @ViewChild(ApLoggerComponent, {static: false})
  public loggerComponent: ApLoggerComponent;

  @ViewChild(ApMachinesLoggerComponent, {static: false})
  public machinesLoggerComponent: ApMachinesLoggerComponent;

  public selectedTab: RessourceTabs = RessourceTabs.Logger;

  constructor(private formStore: FormStore,
              private farmUsersStore: FarmUsersStore,
              private permissionsStore: AccessPermissionsStore,
              private mapViewStore: MapViewStore) {
    this.mapViewStore.hideMapView();
  }

  searchIn(value: string): void {
    switch (this.selectedTab) {
      case RessourceTabs.Logger:
        this.loggerComponent.dynComponent?.dynGrid?.filterGrid(value);
        break;
      case RessourceTabs.MachinesLogger:
        this.machinesLoggerComponent.dynComponent?.dynGrid?.filterGrid(value);
        break;
    }
  }

  createNew(): void {
    let docuComponent: any;
    switch (this.selectedTab) {
      case RessourceTabs.Logger:
        docuComponent = ApLoggerEditComponent;
        break;
      case RessourceTabs.MachinesLogger:
        docuComponent = ApMachinesLoggerEditComponent;
        break;
    }
    this.formStore.openForm({component: docuComponent, data: null});
  }

  selectTab(e): void {
    switch (this.selectedTab) {
      case RessourceTabs.Logger:
        this.loggerComponent.dynComponent?.dynGrid?.filterGrid('');
        break;
      case RessourceTabs.MachinesLogger:
        this.machinesLoggerComponent.dynComponent?.dynGrid?.filterGrid('');
        break;
    }
    this.selectedTab = e.index;
  }
}
